(function () {
  var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
  function money(cents) { return fmt.format(Number(cents || 0) / 100) }
  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)) }
  function one(root, sel) { return root.querySelector(sel) }
  function round1(n) { return Math.round(n * 10) / 10 }
  function plural(n, a, b) { return n + ' ' + (n === 1 ? a : b) }

  function readDims(blob) {
    if (!blob) return Promise.resolve(null)
    var isPng = /png$/i.test(blob.type) || /\.png$/i.test(blob.name || '')
    if (isPng && blob.slice && blob.arrayBuffer) {
      return blob.slice(0, 262144).arrayBuffer().then(function (buf) {
        var v = new DataView(buf)
        if (buf.byteLength < 33 || v.getUint32(0) !== 0x89504e47) return null
        var w = v.getUint32(16)
        var h = v.getUint32(20)
        var dpi = 0
        var o = 8
        while (o + 12 <= buf.byteLength) {
          var len = v.getUint32(o)
          var t = String.fromCharCode(v.getUint8(o + 4), v.getUint8(o + 5), v.getUint8(o + 6), v.getUint8(o + 7))
          if (t === 'pHYs' && o + 17 <= buf.byteLength && v.getUint8(o + 16) === 1) dpi = v.getUint32(o + 8) * 0.0254
          if (t === 'IDAT' || t === 'IEND') break
          o += 12 + len
        }
        return { w: w, h: h, dpi: dpi }
      }).catch(function () { return null })
    }
    if (!/^image\/(jpe?g|webp|gif)$/i.test(blob.type)) return Promise.resolve(null)
    return new Promise(function (res) {
      var img = new Image()
      var src = URL.createObjectURL(blob)
      img.onload = function () { res(img.naturalWidth ? { w: img.naturalWidth, h: img.naturalHeight, dpi: 0 } : null); URL.revokeObjectURL(src) }
      img.onerror = function () { res(null); URL.revokeObjectURL(src) }
      img.src = src
    })
  }

  var UC = 'https://upload.uploadcare.com/'
  var PART = 5242880
  var sdkP = null
  function ucKey() { return (window.UploadKit && window.UploadKit.config && window.UploadKit.config.ucKey) || '17e6328bac29ad4f6365' }
  async function loadSdk() {
    if (!(window.UploadcareUploadClient && window.UploadcareUploadClient.uploadFile)) {
      try {
        var mod = await import('https://esm.sh/@uploadcare/upload-client@6.18.4?bundle')
        if (mod && mod.uploadFile && !window.UploadcareUploadClient) window.UploadcareUploadClient = { uploadFile: mod.uploadFile }
      } catch (e) {}
    }
    var sdk = window.UploadcareUploadClient
    return sdk && sdk.uploadFile ? sdk : null
  }
  function ucSdk() {
    if (!sdkP) sdkP = loadSdk().then(function (sdk) { if (!sdk) sdkP = null; return sdk })
    return sdkP
  }
  function xhr(method, url, body, signal, onProg) {
    return new Promise(function (res, rej) {
      var x = new XMLHttpRequest()
      x.open(method, url)
      if (onProg) x.upload.onprogress = function (e) { if (e.lengthComputable) onProg(e.loaded) }
      x.onload = function () { x.status >= 200 && x.status < 300 ? res(x.responseText) : rej(new Error('Upload service returned ' + x.status)) }
      x.onerror = function () { rej(new Error('Network error, check your connection')) }
      x.onabort = function () { rej(new Error('aborted')) }
      if (signal) signal.addEventListener('abort', function () { x.abort() })
      x.send(body)
    })
  }
  function fd(o) { var f = new FormData(); Object.keys(o).forEach(function (k) { f.append(k, o[k]) }); return f }
  function restUpload(file, name, signal, onPct) {
    var key = ucKey()
    if (file.size < 10485760) {
      var f = fd({ UPLOADCARE_PUB_KEY: key, UPLOADCARE_STORE: '1' })
      f.append('file', file, name)
      return xhr('POST', UC + 'base/', f, signal, function (l) { onPct(l / file.size) }).then(function (t) { return JSON.parse(t).file })
    }
    return xhr('POST', UC + 'multipart/start/', fd({ UPLOADCARE_PUB_KEY: key, UPLOADCARE_STORE: '1', filename: name, size: file.size, content_type: file.type || 'application/octet-stream', part_size: PART }), signal).then(function (t) {
      var st = JSON.parse(t)
      var parts = st.parts || []
      var sent = parts.map(function () { return 0 })
      var next = 0
      function worker() {
        if (next >= parts.length) return Promise.resolve()
        var i = next++
        var chunk = file.slice(i * PART, Math.min(file.size, (i + 1) * PART))
        return xhr('PUT', parts[i], chunk, signal, function (l) { sent[i] = l; onPct(sent.reduce(function (a, b) { return a + b }, 0) / file.size) }).then(function () { sent[i] = chunk.size; return worker() })
      }
      return Promise.all([worker(), worker(), worker(), worker()]).then(function () {
        return xhr('POST', UC + 'multipart/complete/', fd({ UPLOADCARE_PUB_KEY: key, uuid: st.uuid }), signal)
      }).then(function () { return st.uuid })
    })
  }
  function ucUpload(file, signal, onPct) {
    var name = file.name || 'artwork'
    return ucSdk().then(function (sdk) {
      if (!sdk) return restUpload(file, name, signal, onPct).then(function (id) { return 'https://ucarecdn.com/' + id + '/' })
      return sdk.uploadFile(file, { publicKey: ucKey(), store: 'auto', fileName: name, signal: signal, onProgress: function (p) { if (p && typeof p.value === 'number') onPct(p.value) } }).then(function (r) {
        if (!r || !r.cdnUrl) throw new Error('Upload returned no URL')
        return r.cdnUrl
      })
    }).then(function (base) { return base + encodeURIComponent(name) })
  }
  var ACCEPT = /^(image\/|application\/(pdf|msword|postscript|zip|x-zip|illustrator|eps|x-eps|vnd\.adobe))/i
  var EXT = /\.(png|jpe?g|webp|gif|tiff?|bmp|svg|psd|pdf|ai|eps|ps|doc|docx|zip)$/i
  function okType(f) { return ACCEPT.test(f.type || '') || EXT.test(f.name || '') }

  function init(root) {
    if (root.dataset.gsoReady) return
    root.dataset.gsoReady = '1'
    root.classList.add('gso--js')
    var state = { mode: 'upload', art: null, layout: 'one', layoutTouched: false, active: null, noteAuto: false, adding: false }
    var form = one(root, 'form.gso__form')
    var mount = form && one(form, '[data-gso-mount]')
    var picker = mount && one(mount, '[data-gso-input]')
    var propsEl = form && one(form, '[data-gso-props]')
    var variantInput = one(root, '[data-gso-variant]')
    var qtyInput = one(root, '[data-gso-qty-input]')
    var submit = one(root, '[data-gso-submit]')
    var error = one(root, '[data-gso-error]')
    var buildBtn = one(root, '[data-gso-build-open]')
    var buildError = one(root, '[data-gso-build-error]')
    var snapNote = one(root, '[data-gso-build-snap]')
    var opening = false
    var viz = one(root, '[data-gso-viz]')
    var sheetsEl = one(root, '[data-gso-sheets]')
    var shirt = one(root, '.gso__shirt')
    var fit = one(root, '[data-gso-fit]')
    var bar = one(root, '[data-gso-bar]')
    var checkout = one(root, '[data-gso-checkout]')
    var buildPane = one(root, '[data-gso-pane="build"]')
    var uploadBox = one(root, '[data-gso-upload]')
    var filesEl = one(root, '[data-gso-files]')
    var layoutEl = one(root, '[data-gso-layout]')
    var noteBtn = one(root, '[data-gso-note-toggle]')
    var addMore = one(root, '[data-gso-add-more]')
    var dropEl = one(root, '[data-gso-drop]')
    var replaceInput = one(root, '[data-gso-replace-input]')

    var meta = {}
    var order = []
    var seq = 0
    var filesQueued = false

    function set(sel, text) { all(root, sel).forEach(function (el) { el.textContent = text }) }
    function list(mode) { return one(root, '[data-gso-list="' + mode + '"]') }
    function selected(mode) { var l = list(mode); return l && one(l, 'input:checked') }
    function options(mode) { var l = list(mode); return l ? all(l, 'input:not(:disabled)') : [] }
    function optionFor(value) { return options('upload').find(function (o) { return o.value === String(value) }) || null }
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1) }
    function pick(mode, needIn) {
      return options(mode).find(function (i) { return Number(i.dataset.in) >= needIn - 0.5 }) || null
    }
    function select(input) { if (input) { input.checked = true; onTile(input) } }

    function files() { return order.map(function (id) { return meta[id] }).filter(Boolean) }
    function status(m) { return m.st }
    function separate() { return state.layout === 'separate' && order.length > 1 }
    function activeFile() { return meta[state.active] || files()[0] || null }

    function entry(id, info) {
      var m = meta[id]
      if (!m) {
        m = meta[id] = { id: id, name: 'File', size: 0, src: '', dims: null, dimsDone: false, inches: 0, full: false, over: false, variant: '', qty: 1, st: 'busy', pct: 0, url: '', err: '', ctrl: null }
        var cur = selected('upload')
        m.variant = cur ? cur.value : ''
      }
      if (info) {
        if (info.name) m.name = info.name
        if (info.size) m.size = info.size
        if (info.src) m.src = info.src
      }
      return m
    }

    function applyDims(m, d) {
      m.dimsDone = true
      m.dims = d
      if (!d || !d.w || !d.h) { m.inches = 0; m.full = false; return }
      m.inches = 22 * d.h / d.w
      var wideOk = d.dpi ? Math.abs(d.w / d.dpi - 22) <= 0.6 : d.w >= 3000
      m.full = wideOk && m.inches >= 23
      var opt = pick('upload', m.inches)
      var opts = options('upload')
      m.over = !opt && m.full
      if (m.full) {
        m.detected = (opt || opts[opts.length - 1] || {}).value || ''
        if (!m.userSized) m.variant = m.detected
      }
    }

    function autoLayout() {
      var fs = files()
      if (fs.length < 2 || state.layoutTouched) return
      state.layout = fs.some(function (m) { return m.dimsDone && !m.full }) ? 'one' : fs.every(function (m) { return m.dimsDone && m.full }) ? 'separate' : state.layout
    }

    function syncOrder() {
      if (!meta[state.active]) state.active = order[0] || null
      if (order.length < 2) { state.layoutTouched = false; state.noteAuto = false; state.layout = 'one' }
      if (propsEl) {
        var urls = files().map(function (m) { return m.url }).filter(Boolean)
        var key = urls.join('|')
        if (propsEl.dataset.key !== key) {
          propsEl.dataset.key = key
          propsEl.innerHTML = ''
          urls.forEach(function (u, i) {
            var inp = document.createElement('input')
            inp.type = 'hidden'
            inp.name = 'properties[upload_' + (i + 1) + ']'
            inp.value = u
            propsEl.appendChild(inp)
          })
        }
      }
    }

    function artOf(m) {
      if (!m) return null
      return { name: m.name, inches: m.inches || 0, src: m.src }
    }

    function drawStage(input) {
      if (!viz || !sheetsEl) return
      var opts = options(state.mode)
      var key = state.mode + opts.length
      if (sheetsEl.dataset.key !== key) {
        sheetsEl.dataset.key = key
        sheetsEl.innerHTML = ''
        opts.forEach(function (o) {
          var el = document.createElement('div')
          el.className = 'gso__sh'
          el.dataset.value = o.value
          el.innerHTML = '<b class="gso__badge" hidden></b><div class="gso__film"><div class="gso__art" hidden><img alt=""></div><div class="gso__over" hidden></div></div><span>' + o.dataset.ft + '</span>'
          el.addEventListener('click', function () { select(o) })
          sheetsEl.appendChild(el)
        })
      }
      var counts = {}
      var upload = state.mode === 'upload'
      if (upload && separate()) files().forEach(function (m) { counts[m.variant] = (counts[m.variant] || 0) + m.qty })
      else if (upload && order.length > 1 && input) counts[input.value] = order.length
      var artIn = upload && state.art && state.art.inches ? state.art.inches : 0
      var maxIn = opts.reduce(function (m, o) { return Math.max(m, Number(o.dataset.in)) }, 0)
      var view = Math.max(maxIn, artIn)
      var W = viz.clientWidth
      var H = viz.clientHeight - 26
      if (!W || H <= 0) return
      var n = opts.length
      var gap = W < 500 ? 8 : 16
      var s = Math.min(H / view, (W - n * gap) / (22 * n + 32))
      viz.style.setProperty('--sw', (22 * s).toFixed(1) + 'px')
      viz.style.setProperty('--gap', gap + 'px')
      if (shirt) { shirt.style.width = (32 * s).toFixed(1) + 'px'; one(shirt, 'svg').style.height = (29 * s).toFixed(1) + 'px' }
      all(sheetsEl, '.gso__sh').forEach(function (el) {
        var o = opts.find(function (x) { return x.value === el.dataset.value })
        if (!o) return
        var inches = Number(o.dataset.in)
        var on = o === input
        el.classList.toggle('is-on', on)
        el.classList.toggle('is-used', !!counts[o.value])
        var badge = one(el, '.gso__badge')
        var c = counts[o.value]
        badge.hidden = !c
        if (c) badge.textContent = separate() ? '×' + c : plural(c, 'file', 'files')
        badge.style.bottom = (inches * s + 6).toFixed(1) + 'px'
        var film = one(el, '.gso__film')
        film.style.height = (inches * s).toFixed(1) + 'px'
        var art = one(el, '.gso__art')
        var over = one(el, '.gso__over')
        if (on && artIn) {
          art.hidden = false
          art.style.height = (artIn * s).toFixed(1) + 'px'
          var img = one(art, 'img')
          img.hidden = !state.art.src
          if (state.art.src && img.getAttribute('src') !== state.art.src) img.src = state.art.src
          var extra = artIn - inches
          over.hidden = !(extra > 0.5)
          over.style.height = Math.max(0, extra * s).toFixed(1) + 'px'
          over.style.bottom = (inches * s).toFixed(1) + 'px'
        } else {
          art.hidden = true
          over.hidden = true
        }
      })
    }

    function fitButton(opt, label) {
      var b = document.createElement('button')
      b.type = 'button'
      b.textContent = label || 'Use ' + opt.dataset.ft + ' ft, ' + money(opt.dataset.price)
      b.addEventListener('click', function () { select(opt) })
      return b
    }

    function renderFit(sheetIn, input) {
      if (!fit) return
      fit.innerHTML = ''
      fit.classList.remove('is-warn')
      var n = order.length
      if (state.mode !== 'upload' || !n) { fit.hidden = true; return }
      fit.hidden = false
      var msg = document.createElement('span')
      fit.appendChild(msg)
      if (n > 1 && !separate()) {
        msg.textContent = plural(n, 'file', 'files') + ' on one ' + input.dataset.ft + ' ft sheet.'
        return
      }
      var m = activeFile()
      var who = n > 1 ? 'Sheet ' + (order.indexOf(m.id) + 1) + ' of ' + n + ': ' : ''
      var a = state.art
      if (!a || !a.inches) { msg.textContent = who + (m.dimsDone ? m.name : 'Reading ' + m.name + '…'); return }
      var need = pick('upload', a.inches)
      var extra = a.inches - sheetIn
      var dim = '22 × ' + round1(a.inches) + ' in'
      if (extra > 0.5) {
        fit.classList.add('is-warn')
        msg.textContent = who + (n > 1 ? 'this file is ' : 'Your file is ') + dim + ', ' + (need ? 'longer than this sheet.' : 'longer than our longest sheet.')
        if (need) fit.appendChild(fitButton(need))
      } else {
        msg.textContent = who + (n > 1 ? 'this file is ' : 'Your file is ') + dim + ' and fits this sheet.'
        if (need && Number(need.dataset.in) < sheetIn) fit.appendChild(fitButton(need))
      }
    }

    function busyCount() { return files().filter(function (m) { return status(m) === 'busy' }).length }
    function sheetCount() { return files().reduce(function (s, m) { return s + m.qty }, 0) }
    function separateTotal() {
      return files().reduce(function (s, m) { var o = optionFor(m.variant); return s + (o ? Number(o.dataset.price) * m.qty : 0) }, 0)
    }

    function render() {
      syncOrder()
      autoLayout()
      var sep = state.mode === 'upload' && separate()
      if (sep) {
        var am = activeFile()
        var ao = am && optionFor(am.variant)
        if (ao && !ao.checked) ao.checked = true
      }
      var input = selected(state.mode)
      if (!input) return
      var ft = Number(input.dataset.ft)
      var inches = Number(input.dataset.in)
      var price = Number(input.dataset.price)
      var n = order.length
      state.art = state.mode !== 'upload' || !n ? null : n === 1 ? artOf(files()[0]) : sep ? artOf(activeFile()) : null
      var total = state.mode !== 'upload' ? price : sep ? separateTotal() : price * qty()
      if (state.mode === 'upload' && variantInput) variantInput.value = input.value
      set('[data-gso-ro-ft]', ft)
      set('[data-gso-ro-dim]', '22 × ' + inches + ' in')
      set('[data-gso-len-sub]', sep ? 'Sheet ' + (order.indexOf(activeFile().id) + 1) + ' of ' + n : '22 in wide')
      set('[data-gso-total]', money(total))
      var busy = state.mode === 'upload' && busyCount() > 0
      var sheets = sheetCount()
      var barLabel = state.mode !== 'upload' ? ft + ' ft sheet' : sep ? plural(sheets, 'sheet', 'sheets') : n > 1 ? ft + ' ft sheet · ' + plural(n, 'file', 'files') : ft + ' ft sheet'
      set('[data-gso-bar-label]', barLabel)
      set('[data-gso-bar-total]', money(total))
      var mainLabel = state.adding ? 'Adding…' : busy ? 'Uploading…' : sep ? 'Add ' + plural(sheets, 'sheet', 'sheets') + ' to cart' : 'Add to cart'
      set('[data-gso-submit-label]', mainLabel)
      set('[data-gso-go-label]', state.mode === 'build' ? 'Open builder' : !n ? 'Upload file' : busy ? 'Uploading…' : sep ? 'Add ' + plural(sheets, 'sheet', 'sheets') : 'Add to cart')
      all(root, '[data-gso-submit], [data-gso-go]').forEach(function (b) {
        if (busy || state.adding) b.setAttribute('aria-busy', 'true')
        else b.removeAttribute('aria-busy')
      })
      if (checkout) checkout.classList.toggle('is-separate', sep)
      if (error && !busy && error.dataset.kind === 'busy') error.hidden = true
      if (buildBtn && state.mode === 'build') {
        var base = root.dataset.builderUrl || buildBtn.dataset.href.split('?')[0]
        buildBtn.dataset.href = base + '?variant=' + input.value
        var fb = one(root, '[data-gso-build-fallback]')
        if (fb) fb.href = buildBtn.dataset.href
        if (snapNote && Number(snapNote.dataset.ft) !== ft) snapNote.hidden = true
        set('[data-gso-build-size]', 'Starts at ' + ft + ' ft')
        set('[data-gso-build-price]', money(price))
      }
      drawStage(input)
      renderFit(inches, input)
      renderFiles()
      var url = new URL(window.location.href)
      if (state.mode === 'upload') url.searchParams.set('variant', input.value)
      url.hash = state.mode === 'build' ? 'build' : ''
      if (!url.searchParams.get('clientDesignId')) url.searchParams.delete('creatorVersion')
      window.history.replaceState(window.history.state, '', url.toString())
    }

    function onTile(input) {
      if (state.mode === 'upload' && separate()) {
        var m = activeFile()
        if (m) { m.variant = input.value; m.userSized = true }
      }
      render()
    }

    function setMode(mode) {
      if (!list(mode)) return
      var prev = selected(state.mode)
      var prevFt = prev ? Number(prev.dataset.ft) : 0
      state.mode = mode
      all(root, '[data-gso-mode]').forEach(function (b) {
        var on = b.dataset.gsoMode === mode
        b.classList.toggle('is-active', on)
        b.setAttribute('aria-checked', on ? 'true' : 'false')
      })
      all(root, '[data-gso-list]').forEach(function (l) { l.hidden = l.dataset.gsoList !== mode })
      all(root, '[data-gso-pane]').forEach(function (p) { p.hidden = p.dataset.gsoPane !== mode })
      if (prevFt) {
        var opts = options(mode)
        var match = opts.find(function (i) { return Number(i.dataset.ft) === prevFt }) ||
          opts.find(function (i) { return Number(i.dataset.ft) > prevFt }) || opts[opts.length - 1]
        if (match) match.checked = true
        if (snapNote) {
          var snapped = mode === 'build' && match && Number(match.dataset.ft) !== prevFt
          snapNote.hidden = !snapped
          if (snapped) {
            snapNote.dataset.ft = match.dataset.ft
            snapNote.textContent = 'The builder has no ' + prevFt + ' ft sheet, so ' + match.dataset.ft + ' ft is selected. For exactly ' + prevFt + ' ft, upload a finished file.'
          }
        }
      }
      if (error) error.hidden = true
      if (buildError) buildError.hidden = true
      render()
    }

    function setLayout(layout) {
      state.layoutTouched = true
      if (layout === 'separate' && state.layout !== 'separate') {
        var cur = selected('upload')
        files().forEach(function (m) { if (!m.userSized) m.variant = m.detected || (cur ? cur.value : m.variant) })
      }
      if (layout === 'one' && state.layout === 'separate') {
        var am = activeFile()
        var o = am && optionFor(am.variant)
        if (o) o.checked = true
      }
      state.layout = layout
      if (error) error.hidden = true
      render()
    }

    function uploadUrl() { var m = files().find(function (x) { return x.url }); return m ? m.url : '' }
    function urlFor(m) { return m.url || '' }

    function scheduleRender() {
      if (filesQueued) return
      filesQueued = true
      requestAnimationFrame(function () { filesQueued = false; render() })
    }

    function start(m) {
      m.st = 'busy'
      m.pct = 0
      m.err = ''
      m.url = ''
      m.ctrl = window.AbortController ? new AbortController() : null
      var ctrl = m.ctrl
      ucUpload(m.file, ctrl && ctrl.signal, function (v) {
        var p = Math.max(1, Math.min(99, Math.round(v * 100)))
        if (meta[m.id] === m && p !== m.pct) { m.pct = p; scheduleRender() }
      }).then(function (url) {
        if (meta[m.id] !== m || m.ctrl !== ctrl) return
        m.url = url
        m.st = 'done'
        m.pct = 100
        scheduleRender()
      }, function (err) {
        if (meta[m.id] !== m || m.ctrl !== ctrl) return
        m.st = 'error'
        m.err = /abort|cancel/i.test(String(err && (err.name + err.message))) ? 'Upload stopped' : 'Upload failed, try again'
        scheduleRender()
      })
    }

    function addFiles(fl, at) {
      var list = Array.prototype.filter.call(fl || [], function (f) { return f && f.size })
      var bad = list.filter(function (f) { return !okType(f) })
      list = list.filter(okType).slice(0, Math.max(0, 10 - order.length))
      if (bad.length) showError('Upload a PNG, PDF, AI or EPS file.')
      else if (error && error.dataset.kind !== 'busy') error.hidden = true
      list.forEach(function (f, k) {
        var id = 'u' + (++seq)
        var m = entry(id, { name: f.name || 'artwork', size: f.size })
        m.file = f
        if (at && k === 0) {
          order.splice(Math.min(at.index, order.length), 0, id)
          m.qty = at.qty
          if (at.active) state.active = id
        } else order.push(id)
        readDims(f).then(function (d) {
          if (meta[id] !== m) return
          if (/^image\/(png|jpe?g|webp|gif|svg\+xml)$/i.test(f.type) && (!d || d.w * d.h <= 60000000) && f.size <= 104857600) m.src = URL.createObjectURL(f)
          applyDims(m, d)
          scheduleRender()
        })
        start(m)
      })
      scheduleRender()
      return list.length
    }

    function dropFile(id) {
      var m = meta[id]
      if (!m) return
      if (m.ctrl) m.ctrl.abort()
      if (m.src) URL.revokeObjectURL(m.src)
      delete meta[id]
      var k = order.indexOf(id)
      if (k > -1) order.splice(k, 1)
    }

    function browseInput() { return picker }
    function fmtSize(n) { return n >= 1048576 ? (n / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(n / 1024)) + ' KB' }
    function noteInput() { return form && one(form, 'input[name="properties[Notes:]"]') }
    function setNote(open) {
      if (!uploadBox || !noteBtn) return
      uploadBox.classList.toggle('notes-open', open)
      noteBtn.setAttribute('aria-expanded', open ? 'true' : 'false')
      noteBtn.textContent = open ? 'Hide note' : 'Add a note'
    }

    function sizeOptions(m) {
      return options('upload').map(function (o) {
        return '<option value="' + o.value + '"' + (o.value === m.variant ? ' selected' : '') + '>' + o.dataset.ft + ' ft · ' + money(o.dataset.price) + '</option>'
      }).join('')
    }

    function renderLayout(n) {
      if (!layoutEl) return
      layoutEl.hidden = n < 2
      if (n < 2) return
      all(layoutEl, '[data-gso-layout-opt]').forEach(function (b) {
        var on = b.dataset.gsoLayoutOpt === state.layout
        b.classList.toggle('is-active', on)
        b.setAttribute('aria-checked', on ? 'true' : 'false')
      })
      var help = one(layoutEl, '[data-gso-layout-help]')
      if (help) help.textContent = help.dataset[state.layout === 'separate' ? 'sep' : 'one']
    }

    function rowFor(id) {
      var row = one(filesEl, '[data-id="' + id + '"]')
      if (row) return row
      row = document.createElement('div')
      row.className = 'gso__file'
      row.dataset.id = id
      row.innerHTML = '<span class="gso__file-thumb"></span><span class="gso__file-info"><span class="gso__file-name"></span><span class="gso__file-meta"><i></i><span></span></span><span class="gso__file-bar" hidden><span></span></span></span><span class="gso__file-acts"><button type="button" class="gso__linkbtn" data-act="replace">Replace</button><button type="button" class="gso__linkbtn gso__linkbtn--quiet" data-act="remove">Remove</button></span><div class="gso__file-opts" hidden><label class="gso__sel"><span class="gso__sr">Sheet length</span><select data-act="size"></select></label><div class="gso__qty gso__qty--sm"><button type="button" aria-label="Fewer" data-act="dec">−</button><input type="number" min="1" inputmode="numeric" aria-label="Quantity" data-act="qty"><button type="button" aria-label="More" data-act="inc">+</button></div><b class="gso__file-price"></b></div><p class="gso__file-warn" hidden></p>'
      row.addEventListener('click', function (e) {
        var act = e.target.closest('[data-act]')
        var m = meta[id]
        if (!m) return
        var a = act && act.dataset.act
        if (a === 'remove') { dropFile(id); render(); return }
        if (a === 'replace') { startReplace(id); return }
        if (a === 'inc' || a === 'dec') { m.qty = Math.max(1, m.qty + (a === 'inc' ? 1 : -1)); state.active = id; render(); return }
        if (separate() && state.active !== id && !(act && (a === 'size' || a === 'qty'))) { state.active = id; render() }
      })
      one(row, '[data-act="size"]').addEventListener('change', function (e) {
        var m = meta[id]
        if (!m) return
        m.variant = e.target.value
        m.userSized = true
        state.active = id
        render()
      })
      one(row, '[data-act="qty"]').addEventListener('change', function (e) {
        var m = meta[id]
        if (!m) return
        m.qty = Math.max(1, parseInt(e.target.value, 10) || 1)
        state.active = id
        render()
      })
      filesEl.appendChild(row)
      return row
    }

    function renderFiles() {
      if (!mount || !filesEl || !uploadBox) return
      var fs = files()
      var n = fs.length
      var sep = separate()
      uploadBox.classList.toggle('has-file', n > 0)
      filesEl.hidden = !n
      filesEl.classList.toggle('is-multi', n > 1)
      filesEl.classList.toggle('is-separate', sep)
      if (addMore) addMore.hidden = !n || n >= 10
      renderLayout(n)
      var head = one(root, '[data-gso-files-head]')
      if (head) { head.hidden = n < 2; head.textContent = sep ? 'Your sheets (' + n + ')' : 'Files on this sheet (' + n + ')' }
      if (n > 1 && !sep && !state.noteAuto && fs.every(function (m) { return m.dimsDone })) { state.noteAuto = true; setNote(true) }
      var ni = noteInput()
      if (ni) {
        if (!ni.dataset.gsoPh) ni.dataset.gsoPh = ni.getAttribute('placeholder') || ''
        ni.setAttribute('placeholder', n > 1 && !sep ? 'Sizes and copies for each file' : ni.dataset.gsoPh)
      }
      fs.forEach(function (m, i) {
        var row = rowFor(m.id)
        if (filesEl.children[i] !== row) filesEl.insertBefore(row, filesEl.children[i] || null)
        var th = one(row, '.gso__file-thumb')
        if (th.dataset.src !== (m.src || '-')) {
          th.dataset.src = m.src || '-'
          th.textContent = ''
          if (m.src) { var im = document.createElement('img'); im.alt = ''; im.src = m.src; th.appendChild(im) } else th.textContent = (m.name.split('.').pop() || '').slice(0, 4)
        }
        one(row, '.gso__file-name').textContent = m.name
        var st = status(m)
        var pct = st === 'busy' && m.pct ? m.pct : 0
        row.classList.toggle('is-done', st === 'done')
        row.classList.toggle('is-error', st === 'error')
        row.classList.toggle('is-busy', st === 'busy')
        row.classList.toggle('is-active', sep && m.id === state.active)
        var bits = []
        if (sep && m.full) bits.push('22 × ' + round1(m.inches) + ' in')
        else if (m.size) bits.push(fmtSize(m.size))
        bits.push(st === 'done' ? 'Uploaded' : st === 'error' ? m.err : 'Uploading' + (pct ? ' ' + pct + '%' : ''))
        one(row, '.gso__file-meta span').textContent = bits.join(' · ')
        var barEl = one(row, '.gso__file-bar')
        barEl.hidden = st !== 'busy'
        one(barEl, 'span').style.width = (pct ? pct : 8) + '%'
        var opts = one(row, '.gso__file-opts')
        opts.hidden = !sep
        var warn = one(row, '.gso__file-warn')
        warn.hidden = true
        if (sep) {
          var sel = one(row, '[data-act="size"]')
          if (sel.dataset.v !== m.variant + ':' + options('upload').length) { sel.innerHTML = sizeOptions(m); sel.dataset.v = m.variant + ':' + options('upload').length }
          sel.value = m.variant
          var q = one(row, '[data-act="qty"]')
          if (document.activeElement !== q) q.value = m.qty
          var o = optionFor(m.variant)
          one(row, '.gso__file-price').textContent = o ? money(Number(o.dataset.price) * m.qty) : ''
          if (m.full && o && m.inches > Number(o.dataset.in) + 0.5) {
            warn.hidden = false
            warn.textContent = m.over ? 'This file is 22 × ' + round1(m.inches) + ' in, longer than our longest sheet (20 ft).' : 'This file is ' + round1(m.inches / 12) + ' ft long, longer than ' + o.dataset.ft + ' ft.'
          }
        }
      })
      all(filesEl, '.gso__file').forEach(function (r) { if (!meta[r.dataset.id] || order.indexOf(r.dataset.id) < 0) r.remove() })
    }

    function startReplace(id) {
      if (!replaceInput) return
      replaceInput.dataset.target = id
      replaceInput.value = ''
      replaceInput.click()
    }
    if (replaceInput) {
      replaceInput.addEventListener('change', function () {
        var id = replaceInput.dataset.target
        var f = replaceInput.files && replaceInput.files[0]
        if (!f || !meta[id]) return
        replaceFile(id, f)
      })
    }
    function replaceFile(id, f) {
      var m = meta[id]
      if (!m || !okType(f)) { if (m) showError('Upload a PNG, PDF, AI or EPS file.'); return }
      var at = { index: order.indexOf(id), qty: m.qty, active: state.active === id }
      dropFile(id)
      addFiles([f], at)
    }
    root.gsoReplace = replaceFile

    if (picker) picker.addEventListener('change', function () {
      var fl = Array.prototype.slice.call(picker.files || [])
      picker.value = ''
      handFiles(fl)
    })
    if (mount) {
      mount.addEventListener('pointerenter', ucSdk)
      mount.addEventListener('focusin', ucSdk)
    }
    if (addMore) addMore.addEventListener('click', function () { var i = browseInput(); if (i) i.click() })
    if (noteBtn && uploadBox) {
      noteBtn.addEventListener('click', function () {
        var open = !uploadBox.classList.contains('notes-open')
        setNote(open)
        var n = noteInput()
        if (open && n) n.focus()
      })
      setTimeout(function () {
        var n = noteInput()
        if (n && n.value) setNote(true)
      }, 1500)
    }

    function showError(text, kind) {
      if (!error) return
      error.textContent = text
      error.dataset.kind = kind || ''
      error.hidden = false
    }

    function addSeparate() {
      var fs = files()
      var note = noteInput() ? noteInput().value : ''
      var lines = []
      for (var i = 0; i < fs.length; i++) {
        var u = urlFor(fs[i])
        if (!u || !fs[i].variant) { showError('We could not match every file to its upload. Choose One sheet, or add your sheets one at a time.'); return }
        lines.push({ id: Number(fs[i].variant), quantity: fs[i].qty, properties: { 'Notes:': note, upload_1: u } })
      }
      state.adding = true
      if (error) error.hidden = true
      render()
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
      fetch(rootUrl + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: lines }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j } }) })
        .then(function (res) {
          if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Could not add to cart.')
          window.location.href = rootUrl + 'cart'
        })
        .catch(function (err) {
          state.adding = false
          showError(String(err.message || err))
          render()
        })
    }

    function intercept(e) {
      if (state.mode !== 'upload' || !order.length) return false
      if (state.adding) { e.preventDefault(); e.stopImmediatePropagation(); return true }
      if (files().some(function (m) { return status(m) === 'error' })) {
        e.preventDefault()
        e.stopImmediatePropagation()
        showError('Remove or replace the file that did not upload.')
        return true
      }
      if (busyCount()) {
        e.preventDefault()
        e.stopImmediatePropagation()
        showError(order.length > 1 ? 'Your files are still uploading. One moment.' : 'Your file is still uploading. One moment.', 'busy')
        return true
      }
      if (separate()) {
        e.preventDefault()
        e.stopImmediatePropagation()
        addSeparate()
        return true
      }
      return false
    }
    if (submit) window.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-gso-submit]') === submit) intercept(e) }, true)
    if (form) {
      window.addEventListener('submit', function (e) { if (e.target === form) intercept(e) }, true)
      form.addEventListener('submit', function (e) {
        if (uploadUrl()) { if (error) error.hidden = true; return }
        e.preventDefault()
        showError('Add your file to continue.')
        if (mount) mount.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }, true)
    }

    function handFiles(fl) {
      if (!fl || !fl.length) return
      if (state.mode !== 'upload') setMode('upload')
      if (!addFiles(fl)) return
      if (uploadBox && uploadBox.getBoundingClientRect().top > window.innerHeight - 80) uploadBox.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
    function builderOpen() { return !!document.querySelector('.antigroModalContainer') }
    function openBuilder() {
      var input = selected('build')
      if (!input || opening || builderOpen()) return
      var D = window.Designer
      if (!D || typeof D.initializeCreator !== 'function') { window.location.href = buildBtn.dataset.href; return }
      opening = true
      if (buildError) buildError.hidden = true
      buildBtn.setAttribute('aria-busy', 'true')
      buildBtn.disabled = true
      set('[data-gso-build-label]', 'Opening builder…')
      var done = function () {
        opening = false
        buildBtn.removeAttribute('aria-busy')
        buildBtn.disabled = false
        set('[data-gso-build-label]', 'Open builder')
      }
      Promise.resolve()
        .then(function () { return D.initializeCreator(Number(input.value), 1) })
        .then(done, function () { done(); if (buildError) buildError.hidden = false })
    }
    if (buildBtn) buildBtn.addEventListener('click', openBuilder)
    window.addEventListener('message', function (e) {
      if (e.data && e.data.type === 'close') setTimeout(render, 50)
    })

    function hasFiles(e) {
      if (builderOpen()) return false
      var t = e.dataTransfer && e.dataTransfer.types
      return !!t && Array.prototype.indexOf.call(t, 'Files') > -1
    }
    if (dropEl && mount) {
      var depth = 0
      var watch
      var hide = function () { depth = 0; clearTimeout(watch); dropEl.hidden = true }
      window.addEventListener('dragenter', function (e) {
        if (!hasFiles(e)) return
        e.preventDefault()
        ucSdk()
        depth++
        dropEl.hidden = false
      }, true)
      window.addEventListener('dragover', function (e) {
        if (!hasFiles(e)) return
        e.preventDefault()
        e.dataTransfer.dropEffect = 'copy'
        dropEl.hidden = false
        clearTimeout(watch)
        watch = setTimeout(hide, 400)
      }, true)
      window.addEventListener('dragleave', function (e) {
        if (!hasFiles(e)) return
        depth = Math.max(0, depth - 1)
        if (!depth) hide()
      }, true)
      window.addEventListener('drop', function (e) {
        if (!hasFiles(e)) return
        e.preventDefault()
        e.stopPropagation()
        hide()
        handFiles(e.dataTransfer.files)
      }, true)
      window.addEventListener('dragend', hide, true)
    }

    all(root, '[data-gso-mode]').forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.dataset.gsoMode) })
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return
        var btns = all(root, '[data-gso-mode]')
        var next = btns[(btns.indexOf(b) + (e.key === 'ArrowRight' ? 1 : btns.length - 1)) % btns.length]
        next.focus()
        setMode(next.dataset.gsoMode)
      })
    })
    all(root, '[data-gso-layout-opt]').forEach(function (b) {
      b.addEventListener('click', function () { setLayout(b.dataset.gsoLayoutOpt) })
    })
    all(root, '[data-gso-list] input').forEach(function (i) { i.addEventListener('change', function () { onTile(i) }) })
    all(root, '[data-gso-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, qty() + Number(b.dataset.gsoQty))
        render()
      })
    })
    if (qtyInput) qtyInput.addEventListener('input', render)

    all(root, '[data-gso-go]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (state.mode === 'build' && buildBtn) { openBuilder(); return }
        if (order.length && busyCount()) {
          showError(order.length > 1 ? 'Your files are still uploading. One moment.' : 'Your file is still uploading. One moment.', 'busy')
          if (checkout) checkout.scrollIntoView({ behavior: 'smooth', block: 'center' })
          return
        }
        if (uploadUrl() || order.length) { if (submit) submit.click(); return }
        if (mount) {
          mount.scrollIntoView({ behavior: 'smooth', block: 'center' })
          mount.classList.remove('is-flash')
          void mount.offsetWidth
          mount.classList.add('is-flash')
        }
      })
    })

    if (bar && 'IntersectionObserver' in window) {
      var seen = new Map()
      var head = one(root, '.gso__head')
      var update = function () {
        var target = state.mode === 'upload' ? checkout : buildPane
        var headGone = head && head.getBoundingClientRect().bottom < 0
        bar.hidden = !headGone || !!(target && seen.get(target))
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { seen.set(en.target, en.isIntersecting) })
        update()
      }, { threshold: 0.2 })
      ;[checkout, buildPane].filter(Boolean).forEach(function (t) { io.observe(t) })
      window.addEventListener('scroll', update, { passive: true })
    }

    var t
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(render, 120) })

    if (window.location.hash === '#build') setMode('build')
    else render()
  }

  function boot() { all(document, '[data-gso]').forEach(init) }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot)
  else boot()
  document.addEventListener('shopify:section:load', boot)
})()
